module.exports = __webpack_public_path__ + "static/media/icon_phone.37b56c1f.svg";